import React, { createContext, useContext, useEffect, useState } from 'react';
import { Device, Call } from '@twilio/voice-sdk';
import { TwilioError } from 'twilio-video';
import { SocketContext } from './SocketContext';
import { logger } from '../../utils';
import { useTwilioTokenContext } from './useTwilioTokenContext';

export const AudioDeviceContext = createContext<{
    device: Device | null;
    activeCall: Call | null;
}>({
    device: null,
    activeCall: null,
});

export function AudioDeviceContextProvider({ children }: React.PropsWithChildren<{}>): JSX.Element {
    // const { token, loadTwilioToken } = useContext(SocketContext);
    const { token, loadTwilioToken } = useTwilioTokenContext();
    const [device, setDevice] = useState<Device | null>(null);
    const [activeCall, setActiveCall] = useState<Call | null>(null);


    useEffect(() => {
        console.log('[AudioDeviceContext] Token:', token);
        if (!token) return;

        logger({ message: 'Initializing Twilio Device...' });
        const newDevice = new Device(token, {
            sounds: { incoming: 'https://audiocalltest.s3.us-east-2.amazonaws.com/video_reciever_tone.mp3' }
        });

        // newDevice.on('ready', () => logger({ message: `Twilio device is now ready for connection` }));
        // newDevice.on('error', (error: TwilioError) => logger({ message: 'Twilio Device Error', data: error.message }));
        // newDevice.on('offline', () => logger({ message: 'Twilio Device is now offline' }));
        // newDevice.on('busy', () => logger({ message: 'Twilio Device is now busy' }));

        const handleRegistered = () => {
            //=Device.State.Registered
            logger({ message: 'Twilio Device is now registered (ready for connection)' });
        };
        const handleRegistering = () => {
            //=Device.State.Registering
            logger({ message: 'Twilio Device is registering...' });
        };
        const handleUnregistered = () => {
            //=Device.State.Unregistered
            logger({ message: 'Twilio Device is now unregistered' });
        };
        const handleError = (error: TwilioError) => {
            logger({ message: 'Twilio Device Error', data: error.message });
        };

        newDevice.on('registered', handleRegistered);
        newDevice.on('registering', handleRegistering);
        newDevice.on('unregistered', handleUnregistered);
        newDevice.on('error', handleError);

        newDevice.register().catch((error) => {
            logger({ message: 'Device registration failed', data: error.message });
        });

        
        setDevice(newDevice);

        newDevice.on('incoming', (call) => {
            logger({ message: 'Incoming call received', data: call });

            setActiveCall(call);
        });


        return () => {
            newDevice.off('registered', handleRegistered);
            newDevice.off('registering', handleRegistering);
            newDevice.off('unregistered', handleUnregistered);
            newDevice.off('error', handleError);
            newDevice.destroy();
            setDevice(null);
        };
    }, [token]);


    useEffect(() => {
        const handleDeviceOffline = (error: TwilioError) => {
            if (error.code === 31205) {
                loadTwilioToken();
            }
        };
        device?.on('error', handleDeviceOffline);

        return () => {
            device?.off('error', handleDeviceOffline);
        };
    }, [loadTwilioToken]);

    return <AudioDeviceContext.Provider value={{ device, activeCall }}>{children}</AudioDeviceContext.Provider>;
}
